//////////////////////////////////////////////////////////////////////
///     Este componente foi modificado do original do tema.        ///
///     É basicamente igual só removendo/alterando algumas partes. ///
///     Checar novas versões manualmente.                          ///
//////////////////////////////////////////////////////////////////////

import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import withStyles from "@material-ui/core/styles/withStyles";
import footerStyle from "assets/jss/material-dashboard-pro-react/components/footerStyle";

const styles = {
  ...footerStyle,
  noMargin: {
    margin: 0,
  },
  noZIndex: {
    zIndex: "unset",
  },
  right: {
    ...footerStyle.right,
    textAlign: "right",
  },
};

const Footer = ({ ...props }) => {
  const { classes, fluid, white } = props;
  let container = cx({
    [classes.container]: !fluid,
    [classes.containerFluid]: fluid,
    [classes.whiteColor]: white,
    [classes.noZIndex]: true,
  });
  let anchor = classes.a + cx({ [" " + classes.whiteColor]: white });
  return (
    <footer className={classes.footer}>
      <div className={container}>
        <div className={classes.right}>
          &copy; {1900 + new Date().getYear()}{" "}
          <a className={anchor} href="http://www.energycompany.com.br">
            Energy Company
          </a>
          <p className={classes.noMargin}>
            <small>Este site utiliza dados fornecidos pela <a href="https://www.ccee.org.br/" rel="noopener noreferrer" target="_blank">CCEE</a> e <a href="http://www.cvm.gov.br/" rel="noopener noreferrer" target="_blank">CVM.</a></small>
          </p>
        </div>
      </div>
    </footer>
  );
};

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
  fluid: PropTypes.bool,
  white: PropTypes.bool,
};

export default withStyles(styles)(Footer);



// WEBPACK FOOTER //
// ./src/components/EnergyCompany/Footer/Footer.jsx